import { IChatMessageQuery, IChatQuery } from "../../models/chat/query";
import { IChat, IChatMessage, IChatMessages, ISocketMessage } from "../../models/chat/response";
import toggleLoading from "../../utils/helpers/xor";
import { ChatLoading, IInternalState } from "./context";
import paramsReducer, { QueryAction } from "../base/base-reducer";
import { Socket } from "socket.io-client";

type Action =
  | { type: "LOADING"; payload: { loading: ChatLoading | ChatLoading[] } }
  | { type: "SET_LIST"; payload: { list: IChat[] } }
  | { type: "SET_ALL_CHATS"; payload: { data: IChat[] } }
  | { type: "SET_LIST_LIGHT"; payload: { light: IChat[] } }
  | { type: "SET_MESSAGES"; payload: { messages?: IChatMessages } }
  | { type: "SET_SOCKET"; payload: { socket?: Socket } }
  | { type: "NEW_MESSAGE_RECEIVED"; payload:  ISocketMessage  }
  | { type: "SET_SELECTED_CHAT"; payload: { chatId: number } }
  | { type: 'SET_MESSAGE_QUERY'; payload: { query?: IChatMessageQuery } }
  | QueryAction<IChatQuery>;

const isQueryAction = (action: Action): action is QueryAction<IChatQuery> => {
  return action.type === "SET_QUERY" || action.type === "SET_SEARCH";
};
const reducer = (state: IInternalState, action: Action): IInternalState => {

  if (isQueryAction(action)) {
    return paramsReducer<IChatQuery>(state, action);
  }

  switch (action.type) {

    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }
    case "SET_ALL_CHATS": {
      return {
        ...state,
        allChats: action.payload.data,
      };
    }
    case "SET_LIST_LIGHT": {
      return {
        ...state,
        list: action.payload.light,
      };
    }
    case "SET_SOCKET": {
      return {
        ...state,
        socket: action.payload.socket,
      };
    }
    case "SET_MESSAGES": {
      return {
        ...state,
        messages: action.payload.messages,
      };
    }
    case "SET_MESSAGE_QUERY": {
      return {
        ...state,
        messageQuery: {
          ...state.messageQuery,
          ...(action.payload.query || {}),
        },
      };
    }
    case "SET_SELECTED_CHAT": {
      return {
        
        ...state,
        selectedChatId: action.payload.chatId,
      };
    }
    case "NEW_MESSAGE_RECEIVED": {
      const convertedMessage: IChatMessage = {
        body: action.payload.body || "",
        file: action.payload.file || null,
        isPdf: action.payload.isPdf || false,
        created_at: action.payload.created_at || new Date().toISOString(),
        sender_name: action.payload.sender_type === "user" ? "User" : "Admin",
        typeForAdmin: action.payload.typeForAdmin,
      };

      const chatId = Number(action.payload.chat_id);

      if (state.selectedChatId === chatId) {
        return {
          ...state,
          messages: {
            ...(state.messages || {}),
            data: [...(state.messages?.data || []), convertedMessage],
          },
        };
      }

      const currentList = state.list || [];
      const existingChatInList = currentList.find(chat => chat.id === chatId);

      let updatedList: typeof currentList;

      if (existingChatInList) {
        const updatedChat = {
          ...existingChatInList,
          unseen_message_count: (existingChatInList.unseen_message_count || 0) + 1,
        };

        const rest = currentList.filter(chat => chat.id !== chatId);
        updatedList = [updatedChat, ...rest];
      } else {
        const chatFromAll = state.allChats?.find(chat => chat.id === chatId);
        if (!chatFromAll) return state;

        const newChat = {
          ...chatFromAll,
          unseen_message_count: 1,
        };

        updatedList = [newChat, ...currentList];
      }

      return {
        ...state,
        list: updatedList,
      };
    }
    
    

    default:
      return state;
  }
};

export default reducer;
